import { Injectable, Signal, computed, inject } from '@angular/core';
import { ActiveRoleService } from '../active-role.service';
import { ActiveRoleUser, UserRole } from '../user-role.types';
import { ApiSessionService } from './api-session.service';

@Injectable()
export class ApiActiveRoleService extends ActiveRoleService {
  private readonly session = inject(ApiSessionService);
  readonly currentRole: Signal<UserRole> = computed(() => this.session.role());
  readonly currentUser: Signal<ActiveRoleUser> = this.session.user;
  get availableRoles(): readonly UserRole[] { return this.session.me() ? [this.session.role()] : []; }
  setRole(_role: UserRole): void { /* roles are authoritative in the API */ }
}
